"use strict";

export const LongPressNativeProperties = new Set(['minDurationMs', 'maxDist', 'numberOfPointers']);
//# sourceMappingURL=LongPressTypes.js.map